import React from 'react';
import conversationService from '../../services/conversationService';
import { useDispatch, useSelector } from 'react-redux';
import { updateConversation } from '../../store/slices/conversationsSlice';

const ConversationHeader = ({ conversation, currentUser, readOnlyHeader = false, onDeleted, showBack = false, onBack }) => {
  const dispatch = useDispatch();
  const { user } = useSelector(s => s.auth);
  const subject = conversation?.subject || '(no subject)';
  const status = conversation?.status || 'Open';
  const assignee = conversation?.assignedTo?.name || (conversation?.assignedTo ? 'Assigned' : 'Unassigned');
  const isMine = conversation?.assignedTo?._id === user?._id;

  const changeStatus = (e) => {
    const v = e.target.value; if (!v) return;
    dispatch(updateConversation({ id: conversation._id, payload: { status: v } }));
  };
  const assignSelf = () => {
    dispatch(updateConversation({ id: conversation._id, payload: { assignedTo: user?._id } }));
  };
  const unassign = () => {
    dispatch(updateConversation({ id: conversation._id, payload: { assignedTo: null } }));
  };

  const canDelete = (() => {
    if (!currentUser) return false;
    if (currentUser.accountType === 'WHS') {
      return String(conversation?.wholesaler) === String(currentUser._id);
    }
    if (currentUser.accountType === 'ADMIN') {
      if (conversation?.inbox === 'admin') {
        // Only participants can delete admin↔admin
        const p1 = String(conversation?.wholesaler);
        const p2 = String(conversation?.customer?._id || conversation?.customer);
        const me = String(currentUser._id);
        return me === p1 || me === p2;
      }
      return true;
    }
    return false;
  })();

  const onDelete = async () => {
    if (!canDelete) return;
    const hardAllowed = currentUser?.accountType === 'ADMIN';
    const baseMsg = 'Delete this conversation? This cannot be undone for messages visibility.';
    const doHard = hardAllowed && window.confirm(baseMsg + '\n\nClick OK to HARD delete (removes all messages). Click Cancel to soft delete.');
    const confirmed = doHard || window.confirm('Are you sure you want to delete this conversation?');
    if (!confirmed) return;
    try {
      const res = await conversationService.deleteConversation(conversation._id, { hard: !!doHard });
      if (onDeleted) onDeleted(res.id);
    } catch (e) {
      // eslint-disable-next-line no-alert
      alert(e?.response?.data?.message || e?.message || 'Failed to delete conversation');
    }
  };

  return (
    <div className="thread-header">
      <div style={{ display:'flex', alignItems:'center', gap:8, minWidth:0, flex:1 }}>
        {showBack && (
          <button
            className="show-on-mobile"
            onClick={onBack}
            aria-label="Back to conversations"
            style={{ border:'1px solid #ddd', background:'white', borderRadius:6, padding:'6px 8px' }}
          >
            Back
          </button>
        )}
        <div className="thread-title" style={{ fontWeight:600, minWidth:0 }}>{subject}</div>
        <div className="thread-meta">Status: {status} • Assignee: {assignee}</div>
      </div>
      {!readOnlyHeader && (
      <div style={{ display:'flex', gap:8, alignItems:'center' }}>
        <select value={status} onChange={changeStatus} style={{ padding:'6px 8px', border:'1px solid #ddd', borderRadius:6 }}>
          {['Open','Pending','On Hold','Closed'].map(s=> <option key={s} value={s}>{s}</option>)}
        </select>
        {!conversation?.assignedTo && (
          <button onClick={assignSelf} style={{ padding:'6px 10px', border:'1px solid #ddd', background:'white', borderRadius:6 }}>Assign to me</button>
        )}
        {conversation?.assignedTo && isMine && (
          <button onClick={unassign} style={{ padding:'6px 10px', border:'1px solid #ddd', background:'white', borderRadius:6 }}>Unassign</button>
        )}
        {canDelete && (
          <button onClick={onDelete} style={{ padding:'6px 10px', border:'1px solid #ef4444', color:'#ef4444', background:'white', borderRadius:6 }}>Delete</button>
        )}
      </div>
      )}
    </div>
  );
};

export default ConversationHeader;
